var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 17,
    viewBox: "0 0 247 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_6332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2501 1.25708C83.5038 1.25708 83.7356 1.40113 83.8479 1.62866L85.7529 5.48806L90.0132 6.11076C90.2642 6.14745 90.4727 6.32345 90.5509 6.56479C90.6292 6.80613 90.5637 7.07097 90.3819 7.24799L87.2998 10.25L88.0272 14.4911C88.0701 14.7412 87.9672 14.994 87.7619 15.1431C87.5566 15.2923 87.2844 15.3119 87.0598 15.1938L83.2501 13.1903L79.4404 15.1938C79.2158 15.3119 78.9436 15.2923 78.7383 15.1431C78.533 14.994 78.4301 14.7412 78.473 14.4911L79.2004 10.25L76.1183 7.24799C75.9365 7.07097 75.871 6.80613 75.9493 6.56479C76.0275 6.32345 76.236 6.14745 76.487 6.11076L80.7473 5.48806L82.6523 1.62866C82.7646 1.40113 82.9964 1.25708 83.2501 1.25708Z",
    fill: "#FBC94A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_637_6332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.25 1.25708C103.504 1.25708 103.736 1.40113 103.848 1.62866L105.753 5.48806L110.013 6.11076C110.264 6.14745 110.473 6.32345 110.551 6.56479C110.629 6.80613 110.564 7.07097 110.382 7.24799L107.3 10.25L108.027 14.4911C108.07 14.7412 107.967 14.994 107.762 15.1431C107.557 15.2923 107.284 15.3119 107.06 15.1938L103.25 13.1903L99.4404 15.1938C99.2158 15.3119 98.9436 15.2923 98.7383 15.1431C98.533 14.994 98.4301 14.7412 98.473 14.4911L99.2004 10.25L96.1183 7.24799C95.9365 7.07097 95.871 6.80613 95.9493 6.56479C96.0275 6.32345 96.236 6.14745 96.487 6.11076L100.747 5.48806L102.652 1.62866C102.765 1.40113 102.996 1.25708 103.25 1.25708Z",
    fill: "#FBC94A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_637_6332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.25 1.25708C123.504 1.25708 123.736 1.40113 123.848 1.62866L125.753 5.48806L130.013 6.11076C130.264 6.14745 130.473 6.32345 130.551 6.56479C130.629 6.80613 130.564 7.07097 130.382 7.24799L127.3 10.25L128.027 14.4911C128.07 14.7412 127.967 14.994 127.762 15.1431C127.557 15.2923 127.284 15.3119 127.06 15.1938L123.25 13.1903L119.44 15.1938C119.216 15.3119 118.944 15.2923 118.738 15.1431C118.533 14.994 118.43 14.7412 118.473 14.4911L119.2 10.25L116.118 7.24799C115.937 7.07097 115.871 6.80613 115.949 6.56479C116.028 6.32345 116.236 6.14745 116.487 6.11076L120.747 5.48806L122.652 1.62866C122.765 1.40113 122.996 1.25708 123.25 1.25708Z",
    fill: "#FBC94A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_637_6332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25 1.25708C143.504 1.25708 143.736 1.40113 143.848 1.62866L145.753 5.48806L150.013 6.11076C150.264 6.14745 150.473 6.32345 150.551 6.56479C150.629 6.80613 150.564 7.07097 150.382 7.24799L147.3 10.25L148.027 14.4911C148.07 14.7412 147.967 14.994 147.762 15.1431C147.557 15.2923 147.284 15.3119 147.06 15.1938L143.25 13.1903L139.44 15.1938C139.216 15.3119 138.944 15.2923 138.738 15.1431C138.533 14.994 138.43 14.7412 138.473 14.4911L139.2 10.25L136.118 7.24799C135.937 7.07097 135.871 6.80613 135.949 6.56479C136.028 6.32345 136.236 6.14745 136.487 6.11076L140.747 5.48806L142.652 1.62866C142.765 1.40113 142.996 1.25708 143.25 1.25708Z",
    fill: "#FBC94A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_637_6332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.25 1.25708C163.504 1.25708 163.735 1.40113 163.848 1.62866L165.753 5.48806L170.013 6.11076C170.264 6.14745 170.473 6.32345 170.551 6.56479C170.629 6.80613 170.564 7.07097 170.382 7.24799L167.3 10.25L168.027 14.4911C168.07 14.7412 167.967 14.994 167.762 15.1431C167.556 15.2923 167.284 15.3119 167.06 15.1938L163.25 13.1903L159.44 15.1938C159.216 15.3119 158.943 15.2923 158.738 15.1431C158.533 14.994 158.43 14.7412 158.473 14.4911L159.2 10.25L156.118 7.24799C155.936 7.07097 155.871 6.80613 155.949 6.56479C156.027 6.32345 156.236 6.14745 156.487 6.11076L160.747 5.48806L162.652 1.62866C162.764 1.40113 162.996 1.25708 163.25 1.25708Z",
    fill: "#FBC94A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_6332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(75.25 0.263672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_637_6332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(95.25 0.263672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_637_6332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(115.25 0.263672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_637_6332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(135.25 0.263672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_637_6332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(155.25 0.263672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStars);
export default __webpack_public_path__ + "static/media/five-stars.770d3f5f3ab1f834873cc3367af3b022.svg";
export { ForwardRef as ReactComponent };